import moment from "moment";
import settingService from "../service/setting.service";

const state = {
  isLoading: false,
  data: [],
  // { active: ["nl","en",...], base: "nl" } from the setting response, or null
  // on a backend that predates the key -- and on a session restored from
  // localStorage by a build that predates it, which the TTL can keep alive for
  // a further cache window before PMain refetches.
  locales: null,
  expiredTime: null,
};

const actions = {
  async getAll({ commit }, payload) {
    commit("SET_LOADING", true);
    await settingService.fetchAll(payload).then((response) => {
      commit("SET_DATA", response);
      commit("SET_LOADING", false);
    });
  },

  clearAll({ commit }) {
    commit("SET_DATA", []);
  },
};

const mutations = {
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  /**
   * Accepts the service's `{ data, locales }`, and a bare array as well --
   * clearAll commits `[]` directly.
   */
  SET_DATA(state, payload) {
    const body = Array.isArray(payload) || !payload ? { data: payload } : payload;
    state.data = Array.isArray(body.data) ? body.data : [];
    state.locales = body.locales ? body.locales : null;
    const expiredValue = process.env.VUE_APP_CACHE_EXPIRATION_IN_MINUTE
      ? process.env.VUE_APP_CACHE_EXPIRATION_IN_MINUTE
      : 5;
    // Stored as an ISO string, not a moment instance: vuex-persist deep-merges
    // state before stringifying, which turns a moment into a plain object that
    // moment cannot parse back (TypeError: config._d.getTime is not a function).
    state.expiredTime = moment().add(expiredValue, "minute").toISOString();
    console.log(`set expired theme every ${expiredValue} mins`, state.expiredTime);
  },
};

const getters = {
  getIsCurrencyShownAtProduct(state, getters) {
    // Example of accessing another getter
    const generalSettings = getters.general;
    return generalSettings.appSetting.show_currency_at_product ? true : false;
  },

  getIsCurrencyShownAtOrder(state, getters) {
    // Example of accessing another getter
    const generalSettings = getters.general;
    return generalSettings.appSetting.show_currency_at_order ? true : false;
  },
  

  getCurrencySymbol(state, getters) {
    // Example of accessing another getter
    const generalSettings = getters.general;
    return generalSettings.appSetting.currency_symbol;
  },
  cart(state) {
    let found = state.data.filter((item) => item.key === "cart");
    if (found.length >= 1 && found[0] && found[0].value) {
      return found[0].value;
    }
    return null;
  },
  general(state) {
    let found = state.data.filter((item) => item.key === "general");
    if (found.length >= 1 && found[0] && found[0].value) {
      return found[0].value;
    }
    return null;
  },
  menu(state) {
    let found = state.data.filter((item) => item.key === "menu");
    if (found.length >= 1 && found[0] && found[0].value) {
      return found[0].value;
    }
    return null;
  },
  isExpired(state) {
    const raw = state.expiredTime;
    // Anything we cannot read as a time counts as expired, so the settings are
    // refetched. Covers a null cache and the moment-shaped object left behind
    // in localStorage by builds that stored a moment instance here.
    if (typeof raw !== "string" && typeof raw !== "number" && !(raw instanceof Date)) {
      return true;
    }
    const expired = moment(raw);
    if (!expired.isValid()) {
      return true;
    }
    return expired.diff(moment()) < 0;
  },
  /**
   * Locales the tenant has switched on, base first. Empty when the backend does
   * not send the key; PHeader treats empty as "fall back to the built-in pair"
   * rather than as "no languages".
   */
  activeLocales(state) {
    const active = state.locales && state.locales.active;
    if (!Array.isArray(active)) {
      return [];
    }
    return active.filter((locale) => typeof locale === "string" && locale !== "");
  },

  // The locale POSHUB resolves its own fallback chain against. "" when unknown.
  baseLocale(state) {
    const base = state.locales && state.locales.base;
    return typeof base === "string" && base !== "" ? base : "";
  },

  isRestaurantEnabled(state) {
    const generalSetting = getters.general(state);
    return generalSetting && generalSetting.appSetting.table ? true : false;
  },
  getMenuId(state) {
    const generalSetting = getters.general(state);
    return generalSetting && generalSetting.appSetting.menuId
      ? generalSetting.appSetting.menuId
      : "";
  },
};

const theme = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default theme;
